import React from "react";
import {createGlobalStyle} from "styled-components"

const GlobalStyle = createGlobalStyle`
  html, body {
    margin: 0;
    padding: 0;
    overflow: hidden;
   }
`

export const wrapRootElement = ({element}) => (
    <React.Fragment>
        <GlobalStyle/>
        {element}
    </React.Fragment>
)
